import { h, JSX } from 'preact'
import { StateUpdater } from 'preact/hooks'

import { CurrencyValueForm } from 'models/apps'

import { validateCurrencyAmountOnInput, formatCurrencyAmount } from 'app-utils/validate-currency-input'
import { debounce } from 'utils/functions'

interface CalculatorInputProps {
  value: CurrencyValueForm
  setValue: StateUpdater<CurrencyValueForm>
  isBelowMinimalAmount?: boolean
  debounceTime: number
}

const CalculatorInput = ({ value, setValue, isBelowMinimalAmount, debounceTime }: CalculatorInputProps) => {
  const handleAmountOnInput = (event: JSX.TargetedEvent<HTMLInputElement, Event>): void => {
    const inputValue = event.currentTarget.value
    const validatedValue = validateCurrencyAmountOnInput(inputValue)

    debounce(() => {
      setValue(validatedValue)
    }, debounceTime)
  }

  const handleAmountOnBlur = (event: JSX.TargetedEvent<HTMLInputElement, Event>): void => {
    const inputValue = event.currentTarget.value
    const formattedValue = formatCurrencyAmount(inputValue)
    setValue(formattedValue)
  }

  return (
    <div className="calc-widget__options-holder is-input">
      <input
        id="calc-widget__input"
        className={`calc-widget__input ${isBelowMinimalAmount ? 'is-error' : ''}`}
        type="tel"
        placeholder="0,00"
        value={value.currentValueFormatted}
        onInput={handleAmountOnInput}
        onBlur={handleAmountOnBlur}
        maxLength={13}
        data-calculator-value
      />
    </div>
  )
}

export default CalculatorInput
